"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.view = void 0;
var csod = require("player-core");
var ApplicationActions_1 = require("../../actions/ApplicationActions");
function view() {
    var _this = this;
    return {
        state: {
            actionItem: this.props.actionItem,
            showManualEntry: this.props.actionItem.coverLetterText !== "",
            showFileUpload: this.props.actionItem.fileUploadToken.fileUrl === "",
            isOrTextVisible: true,
            isManualCoverLetterVisible: true,
            isFileUploadVisible: true,
            cancelCoverLetterText: csod.locales.get("Cancel Cover Letter", "Cancel Cover Letter"),
            fileUploadIsEnabled: !csod.viewModel.isPreview
        },
        initialize: function () {
            if (!_this.view.state.actionItem.fileUploadToken.value) {
                _this.view.state.actionItem.fileUploadToken.value = ApplicationActions_1.createUUID();
            }
            return new Promise(function (resolve) {
                resolve();
            });
        },
        mounted: function () {
        },
        receivedProps: function (nextProps) {
            _this.view.state.actionItem = nextProps.actionItem;
            _this.view.state.showFileUpload = _this.props.actionItem.fileUploadToken.deleteUrl === '' ? true : false;
            return new Promise(function (resolve) {
                resolve();
            });
        },
        unmount: function () {
        },
        events: {
            onClickManualEntry: function () {
                _this.view.state.showManualEntry = true;
                _this.view.state.isOrTextVisible = false;
                _this.view.state.isFileUploadVisible = false;
                setTimeout(function () {
                    var textarea = document.querySelector('textarea[aria-labelledby="coverLetter_title"]');
                    if (textarea) {
                        textarea.focus();
                    }
                }, 0);
            },
            onDeleteManualEntry: function () {
                _this.view.state.showManualEntry = false;
                _this.view.state.isOrTextVisible = true;
                _this.view.state.isFileUploadVisible = true;
                _this.view.state.actionItem.coverLetterText = "";
            },
            onCoverLetterUploadSuccess: function (data) {
                _this.view.state.actionItem.fileUploadToken.errorMessage = "";
                if (data.files[0].errors !== null && data.files[0].errors.length > 0) {
                    _this.view.state.actionItem.fileUploadToken.errorMessage = data.files[0].errors[0].Value;
                }
                else {
                    var baseUploaderUrl = csod.context.applicationBase + "uploader/";
                    _this.view.state.actionItem.fileUploadToken.title = data.files[0].name;
                    _this.view.state.actionItem.fileUploadToken.fileSize = Math.floor(data.files[0].length / 1000) + ' KB';
                    _this.view.state.actionItem.fileUploadToken.fileUrl = '';
                    _this.view.state.actionItem.fileUploadToken.deleteUrl = baseUploaderUrl + data.files[0].delete_url;
                    _this.view.state.actionItem.fileUploadToken.fileIcon = ApplicationActions_1.getFileIconBasedFromFileType(data.files[0].name);
                    _this.view.state.actionItem.errorMessage = "";
                    _this.view.state.showFileUpload = false;
                    _this.view.state.isOrTextVisible = false;
                    _this.view.state.isManualCoverLetterVisible = false;
                }
                _this.props.onDataChanged();
            },
            onCoverLetterUploadError: function (error, message) {
                if (error != null) {
                    console.log('onFileUploadError:', error);
                    message = _this.props.fileUploadErrorMessage;
                }
                _this.view.state.actionItem.fileUploadToken.errorMessage = message;
            },
            onCoverLetterDelete: function (id) {
                if (_this.view.state.actionItem.fileUploadToken.deleteUrl) {
                    _this.props.onLoadingChanged(true);
                    csod.service.post(_this.view.state.actionItem.fileUploadToken.deleteUrl)
                        .catch(function (error) {
                        _this.props.onLoadingChanged(false);
                    })
                        .then(function (data) {
                        _this.view.state.actionItem.fileUploadToken.value = ApplicationActions_1.createUUID();
                        _this.view.helpers.resetCoverLetterSection();
                        _this.props.onDataChanged();
                        csod.engine.commit();
                        _this.props.onLoadingChanged(false);
                    });
                }
                else {
                    _this.view.helpers.resetCoverLetterSection();
                    _this.props.onDataChanged();
                }
            },
            onChangeCoverLetterText: function (value) {
                var bool = ApplicationActions_1.booleanize(_this.view.state.actionItem.errorMessage);
                _this.view.state.actionItem.coverLetterText = value;
                _this.view.state.actionItem.errorMessage = "";
                _this.props.onDataChanged();
                if (bool)
                    _this.forceRender();
                return false;
            },
            onLoadingChanged: this.props.onLoadingChanged
        },
        helpers: {
            resetCoverLetterSection: function () {
                _this.view.state.actionItem.fileUploadToken.fileUrl = '';
                _this.view.state.actionItem.fileUploadToken.deleteUrl = '';
                _this.view.state.actionItem.fileUploadToken.title = '';
                _this.view.state.actionItem.fileUploadToken.fileSize = 0;
                _this.view.state.showFileUpload = true;
                _this.view.state.isOrTextVisible = true;
                _this.view.state.isManualCoverLetterVisible = true;
            }
        }
    };
}
exports.view = view;



//////////////////
// WEBPACK FOOTER
// C:/WS/ls/build/player-application-workflow/src/.tmp/ApplicationWorkflowCoverLetter/View.js
// module id = 364
// module chunks = 0 2